<template>
    <div class="mainContent">
        <div class="screenMain">
            <div class="tabMenu flex">
                <div :class="activeType==''?'active':''" @click="selectType('')">全部</div>
                <div :class="activeType=='面授'?'active':''" @click="selectType('面授')">面授</div>
                <div :class="activeType=='直播'?'active':''" @click="selectType('直播')">直播</div>
                <div :class="activeType=='录播'?'active':''" @click="selectType('录播')">录播</div>
                <div :class="activeType=='题库'?'active':''" @click="selectType('题库')">题库</div>
            </div>
            <div style="margin-top:10px;">
                <div class="flex subjectCourseMain" v-for="item in subjectList" :key="item.id">
                    <template v-if="item.show==true">
                        <div class="subjectTitle">{{item.name}}</div>
                        <div class="courseList flex" v-if="item.children&&item.children.length>0">
                            <!-- <div class="active">全部</div> -->
                            <div v-for="citem in item.children"
                                 :key="citem.id"
                                 @click="chooseSubject(citem.id)"
                                 :class="selectSubjectId==citem.id?'active':''">{{citem.name}}</div>
                        </div>
                    </template>
                </div>
            </div>
            <div class="moreCourseMain" @click="moreSubject">
                <div v-if="showSubjectAll==false">更多选项</div>
                <div v-else>收起选项</div>
            </div>
        </div>
        <div class="flex" style="justify-content: space-between;font-size:13px;align-items:center;">
            <div class="courseList flex sortDiv">
                <div :class="activeSortType==''?'active':''" @click="selectSortType('')">综合</div>
                <div :class="activeSortType=='on_time desc'?'active':''" @click="selectSortType('on_time desc')">发布时间</div>
                <div :class="activeSortType=='sell_count desc'?'active':''" @click="selectSortType('sell_count desc')">学习人数</div>
            </div>
            <div style="color:#a2aabc;padding-top:30px;">共{{total}}条相关信息</div>
        </div>
    </div>
</template>

<script>
    import axios from "@/api/config";

    export default {
        name: "course-type-template",
        data(){
            return {
                activeType:'',
                activeSortType:'',
                subjectList:[],
                selectSubjectId:'',
                showSubjectAll:false,
                pageNumber:1,
                pageSize:20,
                total:0,
                goodsList:[],
                agentCustom:{}
            }
        },
        methods:{
            selectType(key, keyPath) {
                this.activeType=key;
                this.pageNumber=1;
                this.getGoodsPageList();
            },
            selectSortType(sortType){
                this.pageNumber=1;
                this.getGoodsPageList();
                this.activeSortType=sortType;
            },
            chooseSubject(subjectId){
                if(subjectId==this.selectSubjectId){
                    this.selectSubjectId='';
                }else{
                    this.selectSubjectId=subjectId;
                }
                this.pageNumber=1;
                this.getGoodsPageList();
            },
            moreSubject(){
                this.showSubjectAll=!this.showSubjectAll;
                this.showSubject();
            },
            showSubject(){
                let _this=this;
                if(_this.showSubjectAll==false){
                    if(_this.subjectList&&_this.subjectList.length>0){
                        _this.subjectList.forEach(function (item, index) {
                            if(index>=2){
                                _this.$set(item,'show',false);
                            }else{
                                _this.$set(item,'show',true);
                            }
                        });
                    }
                }else{
                    if(_this.subjectList&&_this.subjectList.length>0){
                        _this.subjectList.forEach(function (item, index) {
                            _this.$set(item,'show',true);
                        });
                    }
                }
                // console.log(_this.subjectList)
            },
            sizeChange(pageSize) {
                this.pageSize = pageSize;
                this.getGoodsPageList();
            },
            currentChange(pageNumber) {
                this.pageNumber = pageNumber;
                this.getGoodsPageList();
            },
            getGoodsPageList(){
                let _this=this;
                axios.post(`${process.env.BASE_URL}schoolPage/getCourseCenterGoodsPageList`,{
                    pageNumber:_this.pageNumber,
                    pageSize:_this.pageSize,
                    type:_this.activeType,
                    subjectId:_this.selectSubjectId,
                    orderBy:_this.activeSortType
                }).then(function(res){
                    if(res.code==0){
                        _this.goodsList=res.data.records;
                        _this.total = res.data.total;
                    }
                })
            },
            toCourseInfo(goodsId){
                this.$router.push({ name: 'courseInfo',query:{id:goodsId}});
            }
        },
        mounted() {
            // this.agentCustom=this.getAgentCustomById(localStorage.getItem("agentId"));
            axios.get(`${process.env.BASE_URL}/subjectCourse/getSubjectTreeListByGoodsInfo`).then(res=>{
                if(res.code==200){
                    this.subjectList=res.data;
                    this.showSubject();
                }
            })
            this.getGoodsPageList();
        },
    }
</script>

<style lang="less" scoped>
    .screenMain{
        background-color: #fff;
        border-radius: 5px;
        // height: 300px;
        margin-top: 30px;
        padding: 20px;
    }
    .tabMenu{
        div{
            margin-right: 40px;
            cursor: pointer;
            padding-bottom: 10px;
        }
        div.active{
            color: #266ef6;
            border-bottom: 2px solid #266ef6;
        }
    }
    .subjectCourseMain{
        font-size: 13px;
    }
    .subjectTitle{
        color: #A2AABC;
        padding-top: 15px;
        width: 70px;
    }
    .courseList{
        margin-left: 10px;
        flex-wrap: wrap;
        flex: 1;
        div{
            padding: 5px 18px;
            cursor: pointer;
            margin-top: 10px;
            background-color:#fff;
            border-radius: 20px;
        }
        .active{
            background-color: #266ef6;
            color: #fff;

        }
    }
    .sortDiv{
        margin: 10px 10px 0 10px;
        div{
            margin:10px 10px 0 0;

        }
    }
    .pageMain{
        padding-top: 20px;
        .el-pagination{
            text-align: center;
        }
    }
    .moreCourseMain{
        text-align:center;cursor: pointer;
        font-size: 13px;color: #a2aabc;
    }
</style>


// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/courseTypeTemplate.vue